/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {PdfJsViewerModule} from 'ng2-pdfjs-viewer';
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';
import {SkeletonElementsModule} from 'skeleton-elements/angular';

import {EmployeesSharedModule} from '../employees/employees-shared.module';
import {FilesModule} from '../files/files.module';
import {FormGeneratorModule} from '../form-generator/form-generator.module';
import {ModalModule} from '../modal/modal.module';
import {MvelModule} from '../mvel/mvel.module';
import {PipesModule} from '../pipes/pipes.module';
import {SdconnectModule} from '../sdconnect/sdconnect.module';
import {UiModule} from '../ui/ui.module';
import {UserModule} from '../user/user.module';

import {EmployeeListComponent} from './employee-list.component';
import {EmployeeNewListComponent} from './list/employee-list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    UserModule,
    UiModule,
    PipesModule,
    ModalModule,
    FilesModule,
    FormGeneratorModule,
    MvelModule,
    PdfJsViewerModule,
    EmployeesSharedModule,
    NgxMaskDirective,
    SkeletonElementsModule,
    SdconnectModule
  ],
  declarations: [
    EmployeeListComponent,
    EmployeeNewListComponent
  ],
  exports: [
    EmployeeListComponent,
    EmployeeNewListComponent
  ],
  providers: [
    provideNgxMask()
  ]
})
export class EmployeesListModule {
}
